import { DoorOpen, Fingerprint, FileCheck2, PenLine } from "lucide-react";

const steps = [
  { icon: DoorOpen, text: "Walk through, guided room by room — nothing gets missed." },
  { icon: Fingerprint, text: "Every photo is fingerprinted (SHA-256) and timestamped the instant it's taken — even offline." },
  { icon: FileCheck2, text: "Finalize into a certified, court-presentable PDF report." },
  { icon: PenLine, text: "Everyone signs — co-tenants, landlord, manager — each via a secure email link. No app or account needed to countersign." },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="bg-white py-24 px-6 md:px-12">
    <div className="max-w-7xl mx-auto">
      <p className="text-[#8A6A00] text-xs font-semibold tracking-widest uppercase">How it works</p>
      <h2 className="mt-3 font-heading font-extrabold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#14213D]">
        From shutter press to countersigned PDF.
      </h2>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {steps.map((s, i) => (
          <div key={i} data-testid={`how-step-${i + 1}`} className="relative">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-[#14213D] flex items-center justify-center shrink-0">
                <span className="font-heading font-bold text-[#C9A227]">{i + 1}</span>
              </div>
              <s.icon className="w-6 h-6 text-[#2C3B5E]" strokeWidth={2} />
            </div>
            <p className="mt-5 text-sm text-[#5B6474] leading-relaxed">{s.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
